/**
 * GO/src/orderservice/orderservice.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SqlFilterEntryOperator = 'None' | 'Equal' | 'NotEqual' | 'Less' | 'Greater' | 'EqualGreater' | 'EqualLess' | 'Contains' | 'NotContains' | 'NotEmpty' | 'Empty';

export const SqlFilterEntryOperator = {
    None: 'None' as SqlFilterEntryOperator,
    Equal: 'Equal' as SqlFilterEntryOperator,
    NotEqual: 'NotEqual' as SqlFilterEntryOperator,
    Less: 'Less' as SqlFilterEntryOperator,
    Greater: 'Greater' as SqlFilterEntryOperator,
    EqualGreater: 'EqualGreater' as SqlFilterEntryOperator,
    EqualLess: 'EqualLess' as SqlFilterEntryOperator,
    Contains: 'Contains' as SqlFilterEntryOperator,
    NotContains: 'NotContains' as SqlFilterEntryOperator,
    NotEmpty: 'NotEmpty' as SqlFilterEntryOperator,
    Empty: 'Empty' as SqlFilterEntryOperator
};
